import React, { Component } from 'react'
import { colors, Text } from 'ic-snacks'
import styled from '@emotion/styled'
import { FormattedMessage } from 'react-intl'
import StandardError from 'legacy/common/errors/StandardError'
import StyledCell from 'domains/shifts/components/StyledCell'
import { errors } from 'utils/error-handling/errors'

const BodyContainer = styled.div({
  height: '100%',
  width: 'calc(100% - 30px)',
  position: 'relative',
  left: '15px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

class ShiftsRowErrorBoundary extends Component {
  state = { hasError: false }

  componentDidCatch = (error: StandardError | Error | null, info: { componentStack?: string }) => {
    this.setState({ hasError: true })

    const meta = error instanceof StandardError ? error.meta : null

    errors.captureException(error, undefined, {
      extra: {
        componentStack: info.componentStack,
        ...meta,
      },
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <StyledCell
          data-testid="shopper-shifts-shift-row-error-boundary"
          firstColumn={1}
          lastColumn={24}
          disabled
          enhancedRecurringShiftsEnabled={false}
        >
          <BodyContainer>
            <Text variant="T.12" fontWeight="light" style={{ color: colors.WHITE }}>
              <FormattedMessage id="shiftsDomain.invalidShift" />
            </Text>
          </BodyContainer>
        </StyledCell>
      )
    }

    return this.props.children
  }
}

export default ShiftsRowErrorBoundary
